import api from './index';
import { Holiday, HolidayEditForm, HolidayForm } from '../types/Holiday.interface';
import { extractContentType, extractFileName, XLSX_CONTENT_TYPE } from '../utils/fetchUtils';
import { ExportPublicHolidaysResponse } from '../types/Holiday.interface';

const BASE = '/public-holidays';

export const getPublicHolidays = async () => {
    return api.get<Holiday[]>(BASE).then((res) => res.data);
};

export const createHoliday = async (data: HolidayForm) => {
    return api.post<Holiday>(`${BASE}`, data).then((res) => res.data);
};

export const updateHoliday = async ({ id, ...data }: HolidayEditForm) => {
    return api.patch<Holiday>(`${BASE}/${id}`, data).then((res) => res.data);
};

export const deleteHoliday = async (id: number) => {
    return api.delete<{ success: boolean }>(`${BASE}/${id}`).then((res) => res.data);
};

export const uploadPublicHolidays = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    return api
        .post<Holiday[]>(`${BASE}/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((res) => res.data);
};

export const exportPublicHolidays = async (): Promise<ExportPublicHolidaysResponse> => {
    const response = await api.get<Blob>(`${BASE}/export`, {
        responseType: 'blob',
    });

    return {
        data: response.data,
        contentType: extractContentType(response.headers) || XLSX_CONTENT_TYPE,
        fileName: extractFileName(response.headers) || 'public-holidays.xlsx',
    };
};
